
    import { css } from 'lit-element';
    export default css`*,:host{box-sizing:border-box}`;
  